module.exports = __webpack_public_path__ + "static/starswhite-f3300c22c209c93da6824ea8fa71d47c.svg";